import type { Dispatch, SetStateAction } from 'react';

import TreatButton from '../../TreatButton';
import { ReactComponent as HamburgerIcon } from '~/assets/hamburger.svg';

const Hamburger = ({
    menuState,
    setMenuState,
}: {
    menuState: boolean;
    setMenuState: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <TreatButton
            type="button"
            className="mr-1 hd:hidden text-blue"
            onClick={() => {
                setMenuState(!menuState);
            }}
        >
            <HamburgerIcon />
        </TreatButton>
    );
};

export default Hamburger;
